import * as React from "react"

const STORAGE_KEY = "songbook:favorites"

function readFavorites(): Set<number> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return new Set()
    }
    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed)) {
      return new Set()
    }
    return new Set(parsed.filter((v): v is number => typeof v === "number"))
  } catch {
    return new Set()
  }
}

export function useFavorites() {
  const [favorites, setFavorites] = React.useState<Set<number>>(() =>
    readFavorites()
  )

  const persist = React.useCallback((next: Set<number>) => {
    setFavorites(next)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(next)))
  }, [])

  const toggleFavorite = React.useCallback(
    (id: number) => {
      const next = new Set(favorites)
      if (next.has(id)) {
        next.delete(id)
      } else {
        next.add(id)
      }
      persist(next)
    },
    [favorites, persist]
  )

  const isFavorite = React.useCallback(
    (id: number) => favorites.has(id),
    [favorites]
  )

  return { favorites, toggleFavorite, isFavorite }
}
